import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { useState } from "react";
import { useTarefa } from "../../../../../contexts/TarefaContext";
import { BFChangeInput } from "../../../../../types/components";
import { DiaSemana, IAgendamentoSemalnamente } from "../../../../../types/tarefa";

interface IDiaSemana {
    titulo: string;
    selecionado: boolean;
    dia: DiaSemana;
}

const AgendamentoSemanal = () => {
    const [tarefa, setTarefa] = useTarefa();
    const agendamento = tarefa.agendamento as IAgendamentoSemalnamente;
    const diasIniciais = agendamento?.dias || [];

    const [diasSemana, setDiasSemana] = useState<IDiaSemana[]>([
        { titulo: "Domingo", selecionado: diasIniciais.includes(0), dia: 0 },
        { titulo: "Segunda", selecionado: diasIniciais.includes(1), dia: 1 },
        { titulo: "Terça", selecionado: diasIniciais.includes(2), dia: 2 },
        { titulo: "Quarta", selecionado: diasIniciais.includes(3), dia: 3 },
        { titulo: "Quinta", selecionado: diasIniciais.includes(4), dia: 4 },
        { titulo: "Sexta", selecionado: diasIniciais.includes(5), dia: 5 },
        { titulo: "Sábado", selecionado: diasIniciais.includes(6), dia: 6 },
    ]);

    function handleSelecionarTodosDias(event: BFChangeInput): void {
        event.preventDefault();

        const novoEstado = diasSemana.map((diaSemana) => {
            return { ...diaSemana, selecionado: true };
        });

        setDiasSemana(novoEstado);
        atualizarTarefaComDias(novoEstado);
    }

    function handleSelecaoAlterado(event: BFChangeInput): void {
        event.preventDefault();

        const novoEstado = diasSemana.map((diaSemana) => {
            if (diaSemana.titulo === event.target.name)
                return { ...diaSemana, selecionado: event.target.checked };
            else
                return { ...diaSemana };
        });

        setDiasSemana(novoEstado);
        atualizarTarefaComDias(novoEstado);
    }

    function atualizarTarefaComDias(estadoDias: IDiaSemana[]): void {
        const novoAgendamento = { ...agendamento };
        novoAgendamento.dias = estadoDias
            .filter((diaSemana) => diaSemana.selecionado)
            .map((diaSemana) => diaSemana.dia);

        setTarefa({
            ...tarefa,
            agendamento: novoAgendamento
        });
    }

    return (
        <Grid container sx={{ marginTop: "25px" }}>
            <Grid lg={12} md={12} item>
                <FormControlLabel control={<Checkbox onChange={handleSelecionarTodosDias} />} label="Selecionar todos os dias" />
            </Grid>

            {diasSemana.map((dia, indice) => (
                <Grid key={indice} lg={3} md={4} item>
                    <FormControlLabel control={<Checkbox
                        name={dia.titulo}
                        onChange={handleSelecaoAlterado}
                        checked={dia.selecionado} />}
                        label={dia.titulo} />
                </Grid>
            ))}
        </Grid>
    );
};

export default AgendamentoSemanal;